<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            inline-prompt
            active-text="正常"
            active-color="#1e90ff"
            inactive-text="停用"
            inactive-color="#f00"
            :active-value="1"
            :inactive-value="0"
            style="--el-switch-off-color: #f00"
          />
        </el-form-item>
        <el-form-item
          label="姓名"
          prop="name"
          :rules="[{ required: true, message: '请填写姓名', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号"
          prop="phone"
          :rules="[
            { required: true, message: '请填写手机号', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.phone"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="state.model.sex">
            <el-radio value="男">男</el-radio>
            <el-radio value="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="证件类型"
          prop="idtype"
          :rules="[
            { required: true, message: '请选择证件类型', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="state.idtype"
            value-key="name"
            @change="onIdTypeChange"
          >
            <el-option
              v-for="item in state.idTypeData"
              :key="item"
              :label="item.name"
              :value="item"
            />
            <template #footer>
              <el-button size="small" @click="onLoadRole()"> 刷新 </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="证件号"
          prop="idcard"
          :rules="[
            { required: true, message: '请填写证件号', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.idcard"></el-input>
        </el-form-item>
        <template v-if="state.is_wj">
          <el-form-item
            label="其他证件类型"
            prop="qtzzlx"
            :rules="[
              {
                required: state.is_wj && state.qtzjlx_data?.length > 0,
                message: '请选择其他证件类型',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="state.model.qtzzlx"
              placeholder="其他证件类型"
              size="large"
            >
              <el-option
                v-for="item in state.qtzjlx_data"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="其他证件号码"
            prop="qtzzhm"
            :rules="[
              {
                required: state.is_wj && state.qtzjlx_data?.length > 0,
                message: '请填写其他证件号码',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.qtzzhm" clearable />
          </el-form-item>
          <el-form-item
            label="国籍"
            prop="gj"
            :rules="[
              {
                required: state.is_wj,
                message: '请选择国籍',
                trigger: 'blur',
              },
            ]"
          >
            <el-select v-model="state.model.gj" placeholder="国籍" size="large">
              <el-option
                v-for="item in state.nationality_data"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="人员地区"
            prop="rydq"
            :rules="[
              {
                required: state.is_wj,
                message: '请选择人员地区',
                trigger: 'blur',
              },
            ]"
          >
            <el-radio-group v-model="state.model.rydq">
              <el-radio value="境内">境内</el-radio>
              <el-radio value="境外">境外</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="出生国家"
            prop="csd"
            :rules="[
              {
                required: state.is_wj,
                message: '请选择出生国家',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="state.model.csd"
              placeholder="出生国家"
              size="large"
            >
              <el-option
                v-for="item in state.csgj_data"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="首次入境时间"
            prop="scrjsj"
            :rules="[
              {
                required: state.is_wj,
                message: '请选择首次入境时间',
                trigger: 'blur',
              },
            ]"
          >
            <el-date-picker
              v-model="state.model.scrjsj"
              type="date"
              placeholder="--首次入境时间--"
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item
            label="预计离境时间"
            prop="yjljsj"
            :rules="[
              {
                required: state.is_wj,
                message: '请选择预计离境时间',
                trigger: 'blur',
              },
            ]"
          >
            <el-date-picker
              v-model="state.model.yjljsj"
              type="date"
              placeholder="--预计离境时间--"
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
            />
          </el-form-item>
          <el-form-item
            label="涉税事项"
            prop="sssx_arr"
            :rules="[
              {
                required: state.is_wj,
                message: '请选择涉税事项',
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              v-model="state.model.sssx_arr"
              placeholder="涉税事项"
              multiple
              size="large"
            >
              <el-option
                v-for="item in $constant.employee_sssx"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { employee_edit, employee_detail } from "@/http/employee";
import { idtype_select, dic_getNationality } from "@/http/dictionary";
import { post_response } from "@/utils/qFormat";
import { ElMessage } from "element-plus";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    let nationality_source = []; //国籍/地区数据源
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      if (props.id) {
        let loadModel = new Promise((suc) => {
          employee_detail(props.id).then((res) => {
            if (res.status == 200) {
              state.model = res.data.data;
              state.idtype = { name: state.model.idtype };
              state.model.admin_role_idArr = state.model.admin_role_ids;
              state.model.sssx_arr = state.model.sssx?.split(",");
              suc();
            }
          });
        });

        Promise.all([onLoadIdType(), loadModel, onLoadNationality()]).then(
          () => {
            if (state.model.idtype != "居民身份证") {
              state.is_wj = true; //是否外籍人员

              const idTypeModel = state.idTypeData.find(
                (w) => w.name == state.model.idtype,
              );
              console.log(idTypeModel);
              
              if (idTypeModel?.id) {
                state.idtype = { name: idTypeModel?.name };
                state.qtzjlx_data = idTypeModel.children; //其他证件类型

                if (idTypeModel.name == "中国护照") {
                  state.nationality_data = nationality_source.filter(
                    (w) => w.value == "中国",
                  );
                } else if (idTypeModel.name?.includes("港澳")) {
                  state.nationality_data = nationality_source.filter(
                    (w) => w.value == "中国香港" || w.value == "中国澳门",
                  );
                } else if (idTypeModel.name?.includes("台湾")) {
                  state.nationality_data = nationality_source.filter(
                    (w) => w.value == "中国台湾",
                  );
                } else {
                  state.nationality_data = nationality_source;
                }
              }
            }
          },
        );
      }
    });

    const onLoadIdType = () => {
      return new Promise((suc) => {
        idtype_select().then((res) => {
          if (res.status == 200) {
            state.idTypeData = res.data.data;
            suc();
          }
        });
      });
    };

    //证件类型选择
    const onIdTypeChange = (item) => {
      state.model.idtype = item.name;
      delete state.model.qtzzlx;
      delete state.model.qtzzhm;
      delete state.model.gj;
      delete state.model.csd;

      if (item.name != "居民身份证") {
        state.is_wj = true; //是否外籍人员
        state.qtzjlx_data = item.children; //其他证件类型

        if (item.name == "中国护照") {
          state.nationality_data = nationality_source.filter(
            (w) => w.value == "中国",
          );
        } else if (item.name?.includes("港澳")) {
          state.nationality_data = nationality_source.filter(
            (w) => w.value == "中国香港" || w.value == "中国澳门",
          );
        } else if (item.name?.includes("台湾")) {
          state.nationality_data = nationality_source.filter(
            (w) => w.value == "中国台湾",
          );
        } else {
          state.nationality_data = nationality_source;
        }

        if (state.nationality_data?.length == 1) {
          state.model.gj = state.nationality_data[0].value;
        }
      } else {
        delete state.is_wj;
        delete state.model.rydq;
        delete state.model.scrjsj;
        delete state.model.yjljsj;
      }
    };

    //获取国籍/地区
    const onLoadNationality = () => {
      return new Promise((suc) => {
        dic_getNationality()
          .then((res) => {
            const { data } = res.data;
            nationality_source = data;
            state.csgj_data = data; //出生国家不受规则限制，可随便选择
            suc();
          })
          .catch(() => {
            suc();
          });
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid, rules) => {
        if (valid) {
          state.model.sssx = state.model.sssx_arr?.join(",");
          employee_edit(state.model).then((res) => {
            post_response(res, emit);
          });
        } else {
          ElMessage({
            type: "warning",
            grouping: true,
            message: rules[Object.keys(rules)[0]][0]?.message,
          });
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      onIdTypeChange,
    };
  },
};
</script>
<style scoped lang="less"></style>
